import React from 'react';
import './ServiceInfos.css';

function ServiceInfos() {
  return (
    <div className="service-infos">
      {/* Section Title */}
      <h2 className="service-infos-title">How we maximize your music revenue</h2>
      
      <div className="service-infos-container">
        
        {/* Service 1 - Full Catalog AI Audit */}
        <div className="service-card">
          {/* Service Tag - Top Right */}
          <div className="service-tag">48h Analysis</div>
          
          <div className="service-icon">
            <img 
              src="/img/rocket.svg" 
              alt="Catalog Audit Icon" 
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <h3 className="service-title">FOR ARTISTS & MANAGERS</h3>
          <h4 className="service-subtitle">Full Catalog Audit</h4>
          
          <div className="service-description">
            <p>Careful, manual analysis of your entire discography on Spotify and Apple Music. We personally identify distribution gaps, metadata issues, and hidden revenue opportunities across all your releases and territories.</p>
            
            <ul className="service-features">
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Complete Spotify & Apple Music Coverage Analysis</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Market Gap Identification (195 Countries)</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Missing Lyrics & Metadata Detection</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Audio Quality Optimization Audit</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Dolby Atmos Eligibility Check</span>
              </div>
            </ul>
            
            <div className="service-pricing">
              <span className="price-starting">PROFESSIONAL</span>
              <span className="price">$390</span>
              <span className="price-period">per catalog</span>
            </div>
          </div>
        </div>

        {/* Service 2 - Label Catalog Audit */}
        <div className="service-card">
          {/* Service Tag - Top Right */}
          <div className="service-tag">Enterprise Level</div>
          
     
          <div className="service-icon">
            <img 
              src="/img/briefcase.svg" 
              alt="Label Audit Icon" 
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <h3 className="service-title">FOR RECORD LABELS</h3>
          <h4 className="service-subtitle">Label Catalog Audit</h4>
          
          <div className="service-description">
            <p>Enterprise-level analysis for record labels managing multiple artists and extensive catalogs. We scan hundreds or thousands of releases to identify massive revenue recovery opportunities across your entire roster.</p>
            
            <ul className="service-features">
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Multi-Artist Catalog Analysis</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Bulk Distribution Gap Detection</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Label-Wide Revenue Optimization</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Priority Artist Revenue Recovery</span>
              </div>
              <div className="service-features-item">
                <div className="service-features-icon">
                  <img 
                    src="/img/check_2.svg" 
                    alt="Check" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <span>Comprehensive Label Revenue Report</span>
              </div>
            </ul>
            
            <div className="service-pricing">
              <span className="price-starting">ENTERPRISE</span>
              <span className="price">Price on Request</span>
              <span className="price-period">per label</span>
            </div>
          </div>
        </div>

      </div>
      
      {/* Premium Strategy Call Section Title */}
      <h2 className="service-cta-section-title">Ready to unlock your music's revenue potential?</h2>
      
      {/* Premium Strategy Call Button */}
      <div className="honest-premium-cta-section">
        <div className="honest-premium-cta-wrapper">
          <div className="honest-premium-cta-free-badge">2 FREE SONG AUDITS</div>
          
          {/* Profile Images with Video Icon - Desktop Version */}
          <div className="honest-cta-profile-container honest-cta-profile-desktop">
            <div className="honest-cta-profile-image honest-cta-profile-image-1">
              <img 
                src="/img/button_img_1.jpg" 
                alt="Audit Specialist" 
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="honest-cta-profile-image honest-cta-profile-image-2">
              <img 
                src="/img/photo_2.webp" 
                alt="Music Analyst" 
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="honest-cta-video-icon">
              <img 
                src="/img/video.svg" 
                alt="Video Call" 
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
          
                                  <a href="https://calendly.com/songaudit" target="_blank" rel="noopener noreferrer" className="honest-premium-cta-button">
            <div className="honest-premium-cta-content">
              {/* Profile Images with Video Icon - Mobile Version */}
              <div className="honest-cta-profile-container honest-cta-profile-mobile">
                <div className="honest-cta-profile-image honest-cta-profile-image-1">
                  <img 
                    src="/img/button_img_1.jpg" 
                    alt="Audit Specialist" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="honest-cta-profile-image honest-cta-profile-image-2">
                  <img 
                    src="/img/photo_2.webp" 
                    alt="Music Analyst" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="honest-cta-video-icon">
                  <img 
                    src="/img/video.svg" 
                    alt="Video Call" 
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
              
              <div className="honest-premium-cta-text">
                <span className="honest-premium-cta-title">15 Minute Getting-to-Know Call</span>
                <span className="honest-premium-cta-subtitle">Let's put your music to work</span>
              </div>
              <div className="honest-premium-cta-arrow">
                <img 
                  src="/img/down.svg" 
                  alt="Arrow" 
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </a>
        </div>
      </div>
      
      {/* Trust Elements */}
      <div className="trust-showcase">
        <div className="trust-showcase-grid">
          <div className="trust-showcase-item">
            <div className="trust-showcase-icon">
              <img 
                src="/img/receive-money.svg" 
                alt="30 Days Guarantee" 
                loading="lazy"
                decoding="async"
                style={{width: '24px', height: '24px'}}
              />
            </div>
            <div className="trust-showcase-text">
              <span className="trust-showcase-title">30 Days Money Back</span>
              <span className="trust-showcase-subtitle">Guarantee</span>
            </div>
          </div>
          
          <div className="trust-showcase-item">
            <div className="trust-showcase-icon">
              <img 
                src="/img/check.svg" 
                alt="Proven Results" 
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="trust-showcase-text">
              <span className="trust-showcase-title">Analyzed 10,000+</span>
              <span className="trust-showcase-subtitle">Music Catalogs</span>
            </div>
          </div>
          
          <div className="trust-showcase-item">
            <div className="trust-showcase-icon">
              <img 
                src="/img/paypal.svg" 
                alt="Payment Options" 
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="trust-showcase-text">
              <span className="trust-showcase-title">Pay with Paypal</span>
              <span className="trust-showcase-subtitle">or Stripe</span>
            </div>
          </div>
          
          <div className="trust-showcase-item">
            <div className="trust-showcase-icon">
              <img 
                src="/img/check.svg" 
                alt="Risk Free" 
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="trust-showcase-text">
              <span className="trust-showcase-title">Revenue Increase</span>
              <span className="trust-showcase-subtitle">Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceInfos; 